export { default as Link, type StearsLinkProps } from "./Link"
export { default } from "./Link"
